
import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import StorageCartModule from "@/store/modules/storage/storageCart.module";
import store from "@/store";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import { StorageFilters } from "@/models/entities/storage/storageFilters.interface";
const storageModule = getModule(StorageCartModule, store);
@Component
export default class SecondaryTypeCard extends Vue {
  @PropSync("elements") listElements: StorageElements[];
  @Prop({ required: true, default: 12 }) itemsPerPage: number;
  @Prop({ required: true, default: 1 }) page: number;
  @Prop({ required: true, default: false }) visiblePrice: boolean;
  @Prop({ required: false, default: 0 }) itemsLength: number;
  @Prop({ required: false, default: "" }) userName: string;
  @Prop({ required: false, default: [] }) adminUsers: string[];
  @Prop({ required: false, default: [] }) savedKeywords: string[];
  @Prop({ required: false, default: null }) currentFilters: StorageFilters;

  private currentItemsPerPage = 12;
  private currentPage = 1;

  mounted(): void {
    if (this.itemsPerPage != this.currentItemsPerPage)
      this.currentItemsPerPage = this.itemsPerPage;
    if (this.currentPage != this.page) this.currentPage = this.page;
  }
  @Watch("itemsPerPage")
  updateLocalItems(): void {
    if (this.currentItemsPerPage != this.itemsPerPage)
      this.currentItemsPerPage = this.itemsPerPage;
  }
  @Watch("page")
  updateLocalPage(): void {
    if (this.page != this.currentPage) this.currentPage = this.page;
  }
  @Watch("currentItemsPerPage")
  updateMainItems(): void {
    if (this.itemsPerPage != this.currentItemsPerPage) {
      this.$emit(
        "updatePagination",
        this.currentPage,
        this.currentItemsPerPage
      );
    }
  }
  @Watch("currentPage")
  updateMainPage(val: number): void {
    this.currentPage = val;
    if (this.page != this.currentPage) {
      this.$emit(
        "updatePagination",
        this.currentPage,
        this.currentItemsPerPage
      );
    }
  }

  private search = "";

  private addQty(element): void {
    let value = parseInt(element.qtySelected);
    value += 1;
    element.qtySelected = value;
    if (element.oldValueSelected != element.qtySelected) {
      element.isDifferent = true;
    } else if (element.oldValueSelected == element.qtySelected) {
      element.isDifferent = false;
    }
  }

  private checkDifference(element): void {
    if (element.qtySelected < 0) element.qtySelected = 0;
    if (element.oldValueSelected != element.qtySelected) {
      element.isDifferent = true;
    } else if (element.oldValueSelected == element.qtySelected) {
      element.isDifferent = false;
    }
  }

  private removeQty(element): void {
    element.qtySelected = parseInt(element.qtySelected);
    if (element.qtySelected > 0) element.qtySelected -= 1;

    if (element.oldValueSelected != element.qtySelected) {
      element.isDifferent = true;
    } else if (element.oldValueSelected == element.qtySelected) {
      element.isDifferent = false;
    }
  }
  private addToCart(element): void {
    if (element.qtySelected > 0) {
      element.keywords = this.savedKeywords;

      element.brand = this.currentFilters.brand;
      element.store = this.currentFilters.model;
      element.year = this.currentFilters.fromYear;
      element.type = this.currentFilters.cartype;

      storageModule.addToCart(element);
      element.isDifferent = false;
      element.oldValueSelected = element.qtySelected;
      element.isInCart = true;
      this.$emit("updateSelected");
    }
  }
  private removeFromCart(element): void {
    storageModule.removeFromCart(element);
    element.isInCart = false;
    this.$emit("updateSelected");
  }
  private expandElement(element): void {
    element.expand = !element.expand;
  }
  private openCertificate(code: string, certificate: string): void {
    this.$emit("openCertificate", code, certificate);
  }
  private openCertificateNAD(code: string, certificate: string): void {
    this.$emit("openCertificateNAD", code, certificate);
  }

  private openLink(link: string): void {
    window.open(link, "_blank");
  }
}
